import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserDetails } from '../model/user';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  currentUser: Observable<UserDetails | undefined> =
    this.authService.onUserSession.pipe(
      map((userDetails) => {
        const session = userDetails;
        let result: UserDetails = undefined;

        if (session?.isValid()) {
          const email = session.idToken.payload.email;
          const customGroups =
            session.idToken.payload['custom:group']?.split('|') || [];
          const groups = customGroups;
          
          let userType: 'unknown' | 'inspire' | 'client' | 'distributor' = 'unknown';
          if (
            email.endsWith('@deltacapita.com') ||
            email.endsWith('@ext.deltacapita.com')
          ) {
            userType = 'inspire';
          } else {
            userType = 'distributor';
          }
          
          result = new UserDetails({
            id: session.accessToken.payload.username,
            name: session.idToken.payload.name,
            email,
            type: userType,
            groups,
            permissions: CurrentUserService.getUserPermissions(
              session.idToken.payload.name
            ),
            services: CurrentUserService.getPlatformServices(),
          });
        }
        return result;
      })
    );

  constructor(private authService: AuthService) {}

  private static getUserPermissions(name) {
    return [
      {
        key: 'GET_HELLO_WORLD',
        name: 'User can get generic message',
        description: '',
        requiredPermissions: [],
        serviceKey: 'HelloWorld',
      },
      {
        key: 'GET_HELLO_USER',
        name: 'User can get only its message',
        description: '',
        requiredPermissions: ['GET_HELLO_WORLD'],
        serviceKey: 'HelloWorld',
      },
    ];
  }

  private static getPlatformServices() {
    return [
      {
        key: 'UserManagement',
        name: 'User Management Service',
        description: 'Just say hello',
        isEnable: true,
      },
      {
        key: 'HelloWorld',
        name: 'Hello World',
        description: 'Just say hello',
        isEnable: true,
      },
    ];
  }
}
